import isEqual from 'lodash.isequal';

export const isEqualValue = (value, other) => isEqual(value, other);
